<template>
  <v-container>
    <h1>Takk for din bestilling hos {{ vendor.name }}</h1>

    <v-alert class="mt-5 mb-5" type="success">
      Din bestilling er mottatt! Du vil få en kvittering på epost. Ditt
      ordrenummer er {{ order.order_number }}.
    </v-alert>

    <OrderSummary :order="order" />
  </v-container>
</template>

<script>
import OrderSummary from "@/components/OrderSummary";
import backend from "@/backend";

export default {
  name: "VendorOrderPlaced",

  components: {
    OrderSummary,
  },

  props: {
    vendorId: {
      type: String,
      required: true,
    },
    orderId: {
      type: String,
      required: true,
    },
  },

  data: function () {
    return {
      vendor: {},
      order: {
        orderlines: [],
      },
    };
  },

  async created() {
    this.vendor = await backend.get(`vendors/${this.vendorId}/`);

    const order_data = await backend.get(`orders/${this.orderId}/`, {
      vendor: this.vendor.id,
    });

    order_data.orderlines = await backend.get("orderlines/", {
      order: order_data.id,
    });

    for (const ol of order_data.orderlines) {
      let product_data = await backend.get(`products/${ol.product}/`, {
        vendor: this.vendor.id,
      });

      ol.product = product_data;
    }

    this.order = order_data;
  },
};
</script>
